<template>
	<div>
		<v-form v-on:submit.prevent="saveProduct">
			<v-layout row wrap>
				<v-flex xs12>
					<p class="title-form mb-0">Detalles del Producto</p>
				</v-flex>
				<v-flex xs12 mb-2>
					<v-layout row wrap>
						<v-flex xs3>
							<v-select
								class="filter-select"
								label="Categorías"
								item-text="name"
								item-value="id"
								:items="categories"
								v-model="model.categoryId"
								hide-details
								single-line
								bottom>
							</v-select>
						</v-flex>
						<v-flex xs3>
							<button-create
								text="Agregar nueva categoría"
								btn-function
								@function-click="form = true">
							</button-create>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs12 mb-2>
					<v-layout row wrap>
						<v-flex xs3>
							<input type="text" class="input-form" placeholder="Nombre del Producto"
							v-model="model.name" />
						</v-flex>
						<v-flex xs3>
							<v-select
								:disabled="!!productId"
								class="filter-select"
								:items="productTypes"
								label="Tipo"
								item-text="name"
								item-value="id"
								hide-details
								single-line
								v-model="model.type">
							</v-select>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs12>
					<v-layout row wrap>
						<v-flex xs6>
							<file-upload-container
								v-bind:label-for="`image-${types.length + 1}`"
								v-on:upload="onUploadImage"
								v-bind:image-url="model.urlImage"
								v-bind:min-resolution="10"
								v-bind:max-resolution="3000"
							/>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs12 mb-2>
					<v-layout row wrap>
						<v-flex xs3>
							<p class="title-form mb-0">Tipo de Unidad</p>
							<v-select
								class="filter-select mt-1"
								:items="types"
								label="Seleccione el tipo"
								item-text="name"
								item-value="id"
								hide-details
								single-line
								v-model="model.unitId">
								<template slot="selection" scope="data">
									<span class="types-tag mr-3" :style="`background-color: ${data.item.color}`">
										{{ data.item.code }}
									</span>
									{{ data.item.name }}
								</template>
								<template slot="item" scope="data">
									<v-list-tile-avatar>
										<span class="types-tag" :style="`background-color: ${data.item.color}`">
											{{ data.item.code }}
										</span>
									</v-list-tile-avatar>
									<v-list-tile-content>
										<v-list-tile-title v-html="data.item.name"></v-list-tile-title>
									</v-list-tile-content>
								</template>
							</v-select>
						</v-flex>
						<v-flex xs3>
							<p class="title-form mb-0">Peso</p>
							<input type="number" class="input-form mt-1" placeholder="Contenido Neto"
							v-model.number="model.weigth"/>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs12 mb-2>
					<v-layout row wrap>
						<v-flex xs3>
							<p class="title-form mb-0">Precio Dólares</p>
							<input
								type="number"
								class="input-form"
								placeholder="0.00"
								step="any"
								v-model.number="model.price" />
						</v-flex>
						<v-flex xs3>
							<p class="title-form mb-0">Precio Soles</p>
							<input
								type="number"
								class="input-form"
								placeholder="0.00"
								step="any"
								v-model.number="model.priceSoles" />
						</v-flex>
					</v-layout>
					<v-layout wrap>
						<v-flex xs3>
							<p class="title-form mb-0">Tipo de Impuestos</p>
							<v-select
								class="filter-select"
								label="Seleccione el tipo"
								item-text="description"
								item-value="id"
								:items="typeTaxes"
								v-model="model.igvId"
								hide-details
								single-line
								bottom>
							</v-select>
						</v-flex>
						<v-flex xs3 mt-3 pt-3>
							<v-checkbox
								class="input-checkbox"
								label="Impuesto Requerido"
								v-model="model.flagIgvRequired"
							>
							</v-checkbox>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
			<div class="actions">
				<v-btn
					type="submit"
					:disabled="isDisabled"
					class="btn-save">
					Guardar
				</v-btn>
			</div>
		</v-form>
		<v-layout row justify-center>
			<v-dialog v-model="form" persistent width="50%">
				<v-card>
					<v-card-title>
						<span class="headline">Agregar Categoría</span>
					</v-card-title>
					<v-card-text>
						<v-layout wrap text-xs-left>
							<v-flex xs12 sm6 pr-1>
								<label class="label-form">Nombre</label>
								<v-text-field
									type="text"
									class="input-border-inset"
									v-model="categoryModel.name">
								</v-text-field>
								<span class="caption red--text"
									v-if="$v.categoryModel.name && $v.categoryModel.name.$invalid">
									El nombre es requerido
								</span>
							</v-flex>
							<v-flex xs12 sm6 px-1>
								<label class="label-form">Código</label>
								<v-text-field
									type="text"
									class="input-border-inset"
									v-model="categoryModel.code">
								</v-text-field>
								<span class="caption red--text"
									v-if="$v.categoryModel.code && $v.categoryModel.code.$invalid">
									El código es requerido
								</span>
							</v-flex>
							<v-flex xs12 sm6 px-1>
								<v-switch
								label="Mostrar en POS"
								hiden-details
								v-model="categoryModel.flagMain"
								class="input-switch"
								>	
								</v-switch>
							</v-flex>
							<v-flex xs12 pl-1 mt-3>
								<label class="label-form">Imagen</label>
								<file-upload-container
									v-bind:label-for="`image-${categories.length + 1}`"
									v-on:upload="onUploadImageCategory"
									v-bind:image-url="categoryModel.urlImage"
									v-bind:min-resolution="10"
									v-bind:max-resolution="3000"
								/>
							</v-flex>
						</v-layout>
					</v-card-text>
					<v-card-actions class="mt-4">
						<v-layout row wrap justify-center>
							<v-flex xs3 pr-2>
								<v-btn
									type="button"
									primary
									class="btn-action"
									@click.native="closeModal">
									Cancelar
								</v-btn>
							</v-flex>
							<v-flex xs3 pl-2>
								<v-btn
									class="btn-action btn-success white--text"
									:disabled="$v.$invalid"
									@click.native="createCategory">
									Guardar
								</v-btn>
							</v-flex>
						</v-layout>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-layout>
	</div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import helper from '@/shared/helper';
import mixin from '@/shared/mixins';
import ButtonCreate from '@/components/shared/ButtonCreate';
import FileUploadContainer from '@/components/shared/FileUpload/FileUploadContainer';
import RadioKeeping from '@/components/shared/RadioKeeping';

const helperData = helper.data();

function created() {
	this.loadUnits();
	this.loadData();
	this.loadTaxes();
}

function closeModal() {
	this.form = false;
	this.categoryModel = {
		code: '',
		name: '',
		flagActive: true,
		flagMain: true,
		urlImage: helperData.preimageUrl,
	};
}

async function createCategory() {
	if (this.categoryModel.urlImage === helperData.preimageUrl) {
		delete this.categoryModel.urlImage;
	}
	await this.$http.post(`${process.env.PRODUCTS_URL}/p/categories`, this.categoryModel);
	this.showNotification('La categoría se creó correctamente.', 'success');
	this.loadUnits();
	this.closeModal();
}

async function loadData() {
	if (this.productId) {
		const response = await this.$http.get(`${process.env.PRODUCTS_URL}/p/products/${this.productId}`);
		response.data.unitId = response.data.unit.id;
		response.data.categoryId = response.data.category.id;
		response.data.type = response.data.type;
		response.data.urlImage = response.data.urlImage ? response.data.urlImage :
			helperData.preimageUrl;
		this.model = response.data;
	}
}

async function loadTaxes() {
	const salesUrl = process.env.SALES_URL;
	const sunatCatalogId = process.env.SUNAT_CATALOG_ID;
	const token = localStorage.getItem(`${process.env.STORAGE_USER_KEY}::token`);
	const headers = {
		headers: {
			authorization: `Bearer ${token}`,
		},
	};
	const url = `${salesUrl}/catalog-sunat-details-list/${sunatCatalogId}`;
	const { data: typeTaxes } = await this.$http.get(url, headers);
	this.typeTaxes = typeTaxes;
	if (!this.model.id) {
		this.model.igvId = typeTaxes.find(tax => tax.code === '10').id;
	}
}

async function loadUnits() {
	const request = [
		this.$http.get(`${process.env.PRODUCTS_URL}/p/units`),
		this.$http.get(`${process.env.PRODUCTS_URL}/p/categories`),
	];
	const [units, categories] = await Promise.all(request);
	this.categories = categories.data;
	this.types = units.data;
}

function onUploadImage(url) {
	this.model.urlImage = url;
}

function onUploadImageCategory(url) {
	this.categoryModel.urlImage = url;
}

async function saveProduct() {
	let dataSend = null;
	if (this.model.urlImage === helperData.preimageUrl) {
		delete this.model.urlImage;
	}
	if (this.productId) {
		dataSend = {
			categoryId: this.model.categoryId,
			name: this.model.name,
			igvId: this.model.igvId,
			price: this.model.price,
			priceSoles: this.model.priceSoles,
			unitId: this.model.unitId,
			type: this.model.type,
			weigth: this.model.weigth,
			flagIgvRequired: this.model.flagIgvRequired,
		};
		if (this.model.urlImage) {
			dataSend.urlImage = this.model.urlImage;
		}
	}
	const method = this.productId ? 'patch' : 'post';
	const url = this.productId ? this.productId : 'create';
	const message = this.productId ? 'editó' : 'creó';
	const data = this.productId ? dataSend : this.model;
	try {
		await this.$http[method](`${process.env.PRODUCTS_URL}/p/products/${url}`, data);
		this.showNotification(`El producto se ${message} correctamente.`, 'success');
		this.$router.push(this.listHref);
	} catch (err) {
		if (err.status === 400) {
			const error = err.data;
			if (error.message === 'ERR_DEFAULT_CATEGORIES') {
				this.showNotification('Categorías por defecto no agregadas', 'error');
			}
			if (error.message === 'BRAND_DEFAULT_NOT_FOUND') {
				this.showNotification('No se encontró una marca por defecto.', 'error');
			}
			if (error.message === 'WAREHOUSE_MAIN_NOT_FOUND') {
				this.showNotification('No se encontró un almacén por defecto.', 'error');
			}
		}
	}
}

function setActiveClass(type) {
	return type.id === this.model.unitId ? 'active' : '';
}

function isDisabled() {
	let disabled = false;
	Object.keys(this.model).forEach((key) => {
		if (key !== 'urlImage' && key !== 'flagIgvRequired'
			&& key !== 'flagIgv') {
			if (!this.model[key]) {
				disabled = true;
			}
		}
	});
	return disabled;
}

function validations() {
	return {
		categoryModel: {
			code: {
				required,
			},
			name: {
				required,
			},
		},
	};
}

export default {
	components: {
		ButtonCreate,
		FileUploadContainer,
		RadioKeeping,
	},
	computed: {
		isDisabled,
	},
	created,
	data() {
		return {
			categories: [],
			categoryModel: {
				code: '',
				name: '',
				flagActive: true,
				urlImage: helperData.preimageUrl,
				flagMain: true,
			},
			form: false,
			listHref: { name: 'product-list' },
			model: {
				categoryId: 0,
				igvId: 0,
				name: '',
				price: null,
				priceSoles: 0,
				type: 1,
				unitId: 0,
				urlImage: helperData.preimageUrl,
				weigth: null,
				flagIgvRequired: false,
			},
			productTypes: [
				{ id: 1, name: 'Almacenable' },
				{ id: 2, name: 'No Almacenable' },
			],
			typeTaxes: [],
			types: [],
		};
	},
	methods: {
		closeModal,
		createCategory,
		loadData,
		loadTaxes,
		loadUnits,
		onUploadImage,
		onUploadImageCategory,
		saveProduct,
		setActiveClass,
	},
	mixins: mixin,
	name: 'create-product',
	props: ['productId'],
	validations,
};
</script>

<style lang="scss" scoped>
.create-product {
	width: 610px;

	.actions {
		margin-top: 26px;
		width: 0;
	}

	.btn-primary {
		color: white;
		background-color: map-get($colors, default-skyblue);
		box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
		font-family: map-get($fonts, bold);
		height: 38px;
		width: 164px;
	}

	.title-form {
		color: map-get($colors, dark);
		font-family: map-get($fonts, medium);
		font-size: map-get($colors, fourteen);
		font-weight: 500;
		padding-top: 10px;
		text-align: left;
	}

	.input-form {
		background-color: white;
		box-shadow: inset 0 2px 5px 0 rgba(0, 0, 0, 0.2);
		height: 40px;
		padding-left: 10px;
		width: 100%;
	}
}

.radio-keeping {
	display: flex;
	font-size: map-get($sizes, fourteen);
}

.types-tag {
	border-radius: 100%;
	color: white;
	display: inline-block;
	font-family: map-get($map: $fonts, $key: bold);
	font-size: map-get($map: $sizes, $key: fourteen);
	height: 23px;
	line-height: 23px;
	width: 23px;
}
</style>



// WEBPACK FOOTER //
// Create.vue?0149441f